import zod from 'zod';
import { zodLimit, zodPage } from './helpers';

export const UserSchemas = {
    Account: zod.object({}),
    Password: zod.object({}),
    Sessions: zod.object({}),
    Calendar: zod.object({}),
    OwnSupportTickets: zod.object({
        page: zodPage,
        limit: zodLimit(),
    }),
    GetOwnSupportTicket: zod.object({
        id: zod.coerce.number(),
    }),
    Notes: zod.object({}),
} as const;
